import { take, call, put, fork, all } from 'redux-saga/effects'
import { hashHistory } from 'react-router'

import fetchApi, { uploadImage } from '../../../../../utils/fetchApi'
import Configs from '../../../../../constants/Config'

function* requestNormalizeGlassesFlow() {
  const INFINITE = true

  while (INFINITE) {
    try {
      const { payload, next } = yield take('REQUEST_NORMALIZE_GLASSES')

      const { glassesList, ownerId } = payload

      // 1st: Upload zip assets
      const uploadRequests = glassesList.map(glasses => {
        const formData = new FormData()
        formData.append('rawAsset', glasses.rawAsset.filePhoto, glasses.rawAsset.preview)
        let s3Bucket = Configs.S3_BUCKET
        return call(uploadImage, `attachments/${s3Bucket}/upload`, formData)
      })
      const uploadResponses = yield all(uploadRequests)

      // 2nd: Request normalize glasses
      const requests = uploadResponses.map((payload, i) => {
        const data = {
          sku: glassesList[i].sku,
          urlList: glassesList[i].urlList,
          rawAsset: payload.result.files.rawAsset[0].name,
          ownerId,
          isGLB: glassesList[i].isGLB
        }
        return call(fetchApi, `Products/requestNormalizeGlasses`, data, { method: 'POST' })
      })
      const responses = yield all(requests)

      if (responses && responses[0] && !responses[0].error) {
        if (next && typeof next === 'function') next()
        hashHistory.push('/v2/glasses-list')
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* uploadNewAssetsFlow() {
  const INFINITE = true

  while (INFINITE) {
    try {
      const { payload, next } = yield take('UPLOAD_NEW_ASSETS')
      const { productId, model, newAsset } = payload

      // 1st: Upload zip assets
      const formData = new FormData()
      formData.append('rawAsset', newAsset, 'asset.zip')
      let s3Bucket = Configs.S3_BUCKET
      const uploadResponse = yield call(uploadImage, `attachments/${s3Bucket}/upload`, formData)

      // 2nd: Request normalize glasses
      const data = {
        ...model,
        rawAsset: uploadResponse.result.files.rawAsset[0].name
      }
      const response = yield call(fetchApi, `Products/${productId}/updateModel`, data, { method: 'PATCH' })

      if (response && !response.error) {
        if (next && typeof next === 'function') next()
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* getGlassesV2Flow() {
  const INFINITE = true

  while (INFINITE) {
    const {
      payload: { id },
      next
    } = yield take('GET_GLASSES_V2')
    yield put({ type: 'CLEAR_GLASSES_STATE' })

    const filter = {
      include: [{ relation: 'model' }, { relation: 'models' }]
    }

    try {
      const response = yield call(fetchApi, `Products/${id}?filter=${JSON.stringify(filter)}`)
      if (response && !response.error) {
        yield put({
          type: 'GET_GLASSES_SUCCESS',
          payload: response
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* addGlassesFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('ADD_GLASSES')

    // const thumbnailArr = payload.thumbnailArr
    // const zipFile = payload.zipFile
    // delete payload.thumbnailArr
    // delete payload.zipFile

    const data = {
      sku: payload.sku,
      urlList: payload.urlList,
      gender: payload.description.gender,
      glassesType: payload.description.glassesType,
      frameType: payload.description.frameType,
      frameShape: payload.description.shape,
      material: payload.description.material,
      publicMode: payload.publicMode,
      globalFlg: payload.globalFlg,
      inStock: payload.inStock,
      brandId: payload.brandId,
      size: payload.description.size,
      color: payload.description.color,
      actualSizes: payload.description.actualSizes
    }

    try {
      // 1st: Create product
      const product = yield call(fetchApi, `Products`, data, { method: 'POST' })

      if (product && !product.error) {
        const reqs = [
          // 2nd: Create model
          call(
            fetchApi,
            `Products/${product.id}/models`,
            { zipUrl: '', photos: '', color: JSON.stringify(payload.color) },
            { method: 'POST' }
          )
        ]

        // 3rd: Create locale
        const productLocales = payload.productLocales
        productLocales.forEach(el => {
          const localeData = {
            localeId: el.localeId,
            price: el.price,
            url: el.shopPath,
            note: el.detail
          }
          reqs.push(call(fetchApi, `Products/${product.id}/locales`, localeData, { method: 'POST' }))
        })

        const productLocaleModel = yield all(reqs)

        if (productLocaleModel && productLocaleModel[0] && !productLocaleModel[0].error) {
          if (next && typeof next === 'function') {
            next(product)
          }
        }

        // const formData = new FormData()
        // formData.append('zipFile', zipFile, product.id + '.zip')
        // for (let i = 0 i < thumbnailArr.length i += 1) {
        // 	formData.append(`thumbnail_${i}`, thumbnailArr[i].filePhoto, product.id + `.thumbnail.${i}.png`)
        // }

        // // 2nd: Update thumbnails, zip
        // const images = yield call(uploadImage, `attachments/${Configs.S3_BUCKET}/upload`, formData)

        // if (images && !images.error) {
        // 	data = {
        // 		zipUrl: images.result.files.zipFile[0].name,
        // 		photos: [],
        // 		color: JSON.stringify(payload.color)
        // 	}
        // 	for (let i = 0 i < thumbnailArr.length i += 1) {
        // 		data.photos.push(images.result.files[`thumbnail_${i}`][0].name)
        // 	}
        // 	data.photos = data.photos.toString()

        // 	// 3rd: Create model
        // 	const model = yield call(fetchApi, `Products/${product.id}/models`, data, { method: 'POST' })

        // 	if (model && !model.error) {
        // 		next()
        // 	}
        // }

        // const qrious = new QRious({
        // 	// value: Configs.API_IMG + payload.userId + '/' + response.id + '.zip',
        // 	value: `${Configs.API_SERVER}app?s=${payload.userId}&g=${response.id}`,
        // 	size: 300
        // })
        // const qrCode = Images.dataURItoBlob(qrious.toDataURL('image/png'))
        // formData.append('qrCode', qrCode, response.id + '.qr.png')

        // if (img && !img.error) {
        // 	yield put({
        // 		type: 'ADD_GLASSES_SUCCESS',
        // 		payload: response
        // 	})
        // 	if (next && typeof next === 'function') {
        // 		next()
        // 	}
        // }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* getGlassesFlow() {
  const INFINITE = true

  while (INFINITE) {
    const {
      payload: { id },
      next
    } = yield take('GET_GLASSES')
    yield put({ type: 'CLEAR_GLASSES_STATE' })

    const filter = {
      include: [
        {
          relation: 'locales',
          scope: { include: { relation: 'locale' } }
        },
        {
          relation: 'models'
        },
        {
          relation: 'brand',
          scope: { fields: ['name'] }
        },
        { relation: 'storeProducts', scope: { fields: ['id'] } }
      ]
    }

    try {
      const response = yield call(fetchApi, `Products/${id}?filter=${JSON.stringify(filter)}`)
      if (response && !response.error) {
        yield put({
          type: 'GET_GLASSES_SUCCESS',
          payload: response
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

// function* getGlassesByStoreFlow() {
// 	const INFINITE = true

// 	while (INFINITE) {
// 		const { payload: { storeId, id }, next } = yield take('GET_GLASSES_BY_STORE')
// 		yield put({ type: 'CLEAR_GLASSES_STATE' })
// 		try {
// 			const response = yield call(fetchApi, `Stores/${storeId}/products/${id}`)
// 			if (response && !response.error) {
// 				yield put({
// 					type: 'GET_GLASSES_SUCCESS',
// 					payload: response
// 				})
// 				if (next && typeof next === 'function') {
// 					next()
// 				}
// 			}
// 		} catch (err) {
// 			yield put({ type: 'REQUEST_ERROR', payload: err })
// 		}
// 	}
// }

function* editGlassesGeneralFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('EDIT_GLASSES_GENERAL')

    const productId = payload.glassesDetail.id
    const productLocales = payload.glassesDetail.locales

    const productData = {
      sku: payload.sku,
      urlList: payload.urlList,
      gender: payload.description.gender,
      glassesType: payload.description.glassesType,
      frameType: payload.description.frameType,
      frameShape: payload.description.shape,
      material: payload.description.material,
      publicMode: payload.publicMode,
      globalFlg: payload.globalFlg,
      inStock: payload.inStock,
      brandId: payload.brandId,
      size: payload.description.size,
      color: payload.description.color,
      actualSizes: payload.description.actualSizes
    }

    try {
      const reqs = [
        // 1st: Update product
        call(fetchApi, `Products/${productId}`, productData, { method: 'PATCH' })
      ]

      // 2nd: Update locale
      const newProductLocales = productLocales.map((el, index) => {
        const productLocaleData = el
        productLocaleData.localeId = payload.productLocales[index].localeId
        productLocaleData.price = payload.productLocales[index].price
        productLocaleData.url = payload.productLocales[index].shopPath
        productLocaleData.note = payload.productLocales[index].detail

        reqs.push(call(fetchApi, `Products/${productId}/locales/${el.id}`, productLocaleData, { method: 'PUT' }))
        return productLocaleData
      })

      const response = yield all(reqs)

      if (response && response[0] && !response[0].error) {
        yield put({
          type: 'EDIT_GLASSES_GENERAL_SUCCESS',
          payload: { product: response[0], locales: newProductLocales }
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* createGlassesLocaleInfoFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('CREATE_GLASSES_LOCALE_INFO')

    const productId = payload.productId

    try {
      const data = {
        localeId: '',
        price: '',
        url: '',
        note: ''
      }

      const productLocale = yield call(fetchApi, `Products/${productId}/locales`, data, { method: 'POST' })

      if (productLocale && !productLocale.error) {
        yield put({
          type: 'CREATE_GLASSES_LOCALE_INFO_SUCCESS',
          payload: productLocale
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* deleteGlassesLocaleInfoFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('DELETE_GLASSES_LOCALE_INFO')

    const productId = payload.productId
    const productLocaleId = payload.productLocaleId

    try {
      const response = yield call(fetchApi, `Products/${productId}/locales/${productLocaleId}`, {}, { method: 'DELETE' })

      if (response && !response.error) {
        yield put({
          type: 'DELETE_GLASSES_LOCALE_INFO_SUCCESS',
          payload: { id: productLocaleId }
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* createGlassesModelFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('CREATE_GLASSES_MODEL')

    const productId = payload.productId

    try {
      const productModel = yield call(
        fetchApi,
        `Products/${productId}/models`,
        { zipUrl: '', photos: '', color: JSON.stringify(payload.color) },
        { method: 'POST' }
      )

      if (productModel && !productModel.error) {
        yield put({
          type: 'CREATE_GLASSES_MODEL_SUCCESS',
          payload: productModel
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* deleteGlassesModelFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('DELETE_GLASSES_MODEL')

    const productId = payload.productId
    const modelId = payload.modelId

    try {
      const response = yield call(fetchApi, `Products/${productId}/models/${modelId}`, {}, { method: 'DELETE' })

      if (response && !response.error) {
        yield put({
          type: 'DELETE_GLASSES_MODEL_SUCCESS',
          payload: { id: modelId }
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* editGlassesModelFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('EDIT_GLASSES_MODEL')

    const productId = payload.glassesDetail.id
    const modelId = payload.model.id
    const thumbnailArr = payload.thumbnailArr
    const zipFile = payload.zipFile

    const isThumbnailChanged = payload.isThumbnailChanged
    const isGlassesChanged = payload.isGlassesChanged

    try {
      if (!isThumbnailChanged && !isGlassesChanged) {
        const data = {
          id: modelId,
          zipUrl: payload.model.zipUrl,
          photos: payload.model.photos,
          color: JSON.stringify(payload.color)
        }

        // 2nd: Update model
        const productModel = yield call(fetchApi, `Products/${productId}/updateModel`, data, { method: 'PATCH' })

        if (productModel && !productModel.error) {
          yield put({
            type: 'EDIT_GLASSES_MODEL_SUCCESS',
            payload: productModel
          })
          if (next && typeof next === 'function') {
            next()
          }
        }
      } else {
        const formData = new FormData()
        if (isGlassesChanged) {
          formData.append('zipFile', zipFile, `${productId}.zip`)
        }
        if (isThumbnailChanged) {
          for (let i = 0; i < thumbnailArr.length; i += 1) {
            formData.append(`thumbnail_${i}`, thumbnailArr[i].filePhoto, `${productId}.thumbnail.${i}.png`)
          }
        }

        // 1st: Upload thumbnails, zip
        let s3Bucket = Configs.S3_BUCKET
        // if (Auth.s3Url()) {
        // 	const subDomains = Auth.s3Url().split('.')
        // 	if (subDomains.length > 0) {
        // 		const firstSub = subDomains[0]
        // 		if (firstSub.indexOf('http://') >= 0) {
        // 			s3Bucket = firstSub.split('http://')[1]
        // 		} else if (firstSub.indexOf('https://') >= 0) {
        // 			s3Bucket = firstSub.split('https://')[1]
        // 		}
        // 	}
        // }
        const images = yield call(uploadImage, `attachments/${s3Bucket}/upload`, formData)

        if (images && !images.error) {
          // const data = {
          // 	zipUrl: images.result.files.zipFile[0].name,
          // 	photos: [],
          // 	color: JSON.stringify(payload.color)
          // }
          const data = {
            id: modelId,
            zipUrl: payload.model.zipUrl,
            photos: payload.model.photos,
            color: JSON.stringify(payload.color)
          }

          if (isGlassesChanged) {
            data.zipUrl = images.result.files.zipFile[0].name
          }
          if (isThumbnailChanged) {
            data.photos = []
            for (let i = 0; i < thumbnailArr.length; i += 1) {
              data.photos.push(images.result.files[`thumbnail_${i}`][0].name)
            }
            data.photos = data.photos.toString()
          }

          // 2nd: Update model
          const productModel = yield call(fetchApi, `Products/${productId}/updateModel`, data, { method: 'PATCH' })
          // const [productModel, _] = yield all([
          //   call(fetchApi, `Products/${productId}/models/${modelId}`, data, { method: 'PUT' }),
          //   call(fetchApi, `Products/${productId}`, {
          //     status: Auth.userId() === 26 ? PRODUCT_STATUS.GOLIVE : PRODUCT_STATUS.DELIVERED
          //   }, { method: 'PATCH' }),
          // ])

          if (productModel && !productModel.error) {
            yield put({
              type: 'EDIT_GLASSES_MODEL_SUCCESS',
              payload: productModel
            })
            if (next && typeof next === 'function') {
              next()
            }
          }
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

export default function* glassesDetailFlow() {
  yield fork(addGlassesFlow)
  yield fork(getGlassesFlow)
  yield fork(editGlassesGeneralFlow)
  yield fork(createGlassesLocaleInfoFlow)
  yield fork(deleteGlassesLocaleInfoFlow)
  yield fork(createGlassesModelFlow)
  yield fork(editGlassesModelFlow)
  yield fork(deleteGlassesModelFlow)
  yield fork(requestNormalizeGlassesFlow)
  yield fork(getGlassesV2Flow)
  yield fork(uploadNewAssetsFlow)
}



// WEBPACK FOOTER //
// ./routes/app/routes/glasses-detail/saga/index.js